export default [["vayu-loader", "animate-spin"], {}];
